import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DownloadPanel } from '../../Components/DownloadPanel/DownloadPanel';
import { ExplorePanel } from '../../Components/ExplorePanel/ExplorePanel';
import { PublishTestPanel } from '../../Components/PublishTestPanel/PublishTestPanel';
import QueryPanel from '../../Components/QueryPanel/QueryPanel';
import QueryResults from '../../Components/QueryResults/QueryResults';
import SelectionsHeader from '../../Components/SelectionsHeader/SelectionsHeader';
import { ShareLink } from '../../Components/ShareLink/ShareLink';
//import SwitchView from '../../Components/SwitchView/SwitchView';
import { selectIdsForDownload, selectItemRequest, selectTabDataEntities } from '../../redux/queryResults';
import { GridItem } from '../../redux/queryResults/models';
import { selectControls } from '../../redux/controls';
import { selectDownloading } from '../../redux/queryResults';

import './SearchQuestionsPage.scss';
import gaEvents from '../../shared/analyticsEvents';

function SearchQuestionsPage(): JSX.Element {
  const itemRequest = useSelector(selectItemRequest);
  const gridItemEntities = useSelector(selectTabDataEntities);
  const controls = useSelector(selectControls);
  const idsForDownload = useSelector(selectIdsForDownload);
  const isDownloading = useSelector(selectDownloading); // for downloading of published items

  // Lifted sort state to pass to both ListView, DownloadPanel, and PublishPanel
  const [tabData, setTabData] = useState<GridItem[]|null>(null);

  const [showQP, setShowQP] = useState<boolean>(true);
  const [isEnabledHideColumnButton, setIsEnabledHideColumnButton] = useState(false);
  const [isEnabledSharelinkButton, setIsEnabledShareLinkButton] = useState(false);
  const [showFullTable, setShowFullTable] = useState(true);

  const toggleShowQP =  () => { if (isEnabledHideColumnButton) setShowQP(!showQP); gaEvents.onGA4ShowHideQP(showQP ? 'Hide' : 'Show' ); };
  const toggleShowTable =  () => {setShowFullTable(!showFullTable); gaEvents.onGA4ShowHideQuestions(showFullTable ? 'Hide' : 'Show' );};

  // Reset tabData for ListView when there are no gridItemEntities i.e. tabularResponse comes back empty
  useEffect(() => {
    if (!gridItemEntities) {
      setTabData(null);
      setIsEnabledHideColumnButton(false);
      setIsEnabledShareLinkButton(false);
      setShowFullTable(true);
    } else {
      setIsEnabledHideColumnButton(true);
      setIsEnabledShareLinkButton((!!idsForDownload && !!Object.keys(idsForDownload).length));
    }
  }, [gridItemEntities, idsForDownload]);

  useEffect(() => {
    if (isDownloading) {
      setIsEnabledHideColumnButton(false);
      setIsEnabledShareLinkButton(false);
    } else if (gridItemEntities) {
      setIsEnabledHideColumnButton(true);
      setIsEnabledShareLinkButton((idsForDownload ? Object.keys(idsForDownload).length > 0 : false));
    } else {
      setIsEnabledHideColumnButton(false);
      setIsEnabledShareLinkButton(false);
    }
  }, [isDownloading, gridItemEntities, idsForDownload]);

  useEffect(() => {
    const tableBodyCollection = document.getElementsByClassName('tab-data-body') as HTMLCollectionOf<HTMLDivElement>;
    if (tableBodyCollection.length > 0) {
      const tableBody = tableBodyCollection[0];
      if (showFullTable) {
      // show table
        tableBody.style.maxHeight = '214px';
      } else {
      // shrink table
        // scroll to the first selected item in the table
        const tr = tableBody.getElementsByClassName('selected-item-detail')[0] as HTMLTableRowElement;
        if (tr) {
          tr.scrollIntoView();
          //get parent item
          tableBody.style.maxHeight = tr.clientHeight.toString() + 'px';
          // align scroll to the top of the selected item
          tableBody.scrollTop = tr.offsetTop;
        } else {
          // scroll to the top of the table
          tableBody.scrollTop = 0;
          // get first row in the table
          const tr1 = tableBody.getElementsByTagName('tr')[0];
          tableBody.style.maxHeight = tr1.clientHeight.toString() + 'px';
        }
      }
    }
  }, [showFullTable]);

  return (
    <main className="nqt-sq container-fluid">
      <div className="nqt-sq--row row row-cols-1">
        <div className="nqt-sq--selections col">
          <SelectionsHeader/>
        </div>
        {/* <div className="nqt-sq--switch-view col-5 offset-7">
          <SwitchView />
        </div> */}
      </div>
      <div id='nqt-sq--rowshowhide' className="row nqt-sq--row mb-1 me-0 pe-0 ge-0" >
        <div  className={`g-0  ${showQP ? 'col-2': 'col-1A' }` }>
          
          <div id="nqt-sq--h3" className="mb-2">
            <div className="show-hide-qp--container">
              <button disabled={!isEnabledHideColumnButton}  id='show-hide-qp'
                className={'button nqt-hideshow-button ' + (isEnabledHideColumnButton ? '' : ' nqt-sq--disabled')
                + ((showQP ) ? ' nqt-sq--sp-showing' :  ' nqt-sq--large-font ')}
                type="button" onClick={toggleShowQP}>
                { showQP ? controls?.HideColumn?.controlText : controls?.ShowColumn?.controlText }
              </button>
            </div>
          </div>
        </div>
        {/* <div className='g-0 col-1B'>1</div> */}
        <div className="col-4B pe-0">
          <ShareLink sharingURL={window.location.origin} isEnabled={(isEnabledSharelinkButton )}  />
        </div>
        <div id="nqt-sq--hide-table" className={`col-2 pe-0 ${showQP ? 'offset-4A': 'offset-4B' }`}>
          <div className={showQP ? 'nqt-sq--rt-align-btn' : 'nqt-sq--adjust-button' }>
            <button id='nqt-sq--show-hide-table' className={showQP ? '': 'nqt-sq--adjust-button' } disabled={!gridItemEntities} onClick={toggleShowTable}>
              { showFullTable ? controls?.HideTable?.controlText : controls?.ShowTable?.controlText }
            </button>
          </div>
        </div>
      </div>
      <div className={`nqt-sq--row row ${showQP ? '': 'nqt-sq-no-lpad'}`}>
        <div className={`nqt-sq--col-1  ${showQP ? 'col-2': 'nqt-sq-hidden nqt-qp--show-space-left'}`} >
          <QueryPanel/>
          {
            itemRequest &&
            <>
              <PublishTestPanel tabData={tabData}/>
              <ExplorePanel tabData={tabData}/>
              <DownloadPanel tabData={tabData} />
            </>
          }
        </div>
        <div className={`nqt-sq--col-2 col-10 ${showQP ? '' : 'nqt-sq-no-lpad'} pe-0`}>
          <QueryResults tabData={tabData} setTabData={setTabData} showFullTable={showFullTable}/>
        </div>
      </div>
    </main>
  );
}

export default SearchQuestionsPage;
